import { Alert, Button, Col, Form, Input, Modal, Row, Space, Tag, Typography } from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import { AiOutlineHistory } from 'react-icons/ai';
import { BiRefresh } from 'react-icons/bi';
import { GoRepoPush } from "react-icons/go";
import { TbTruckDelivery } from 'react-icons/tb';
import { trackPromise, usePromiseTracker } from 'react-promise-tracker';
import { useOperationHook } from '../../../../../hooks/useOperationHook';
import { useIsWaybillFromParam, useWaybillResolver } from '../../../../../hooks/useWaybillResolver';
import { IManifestationRequest, INorDelivery } from '../../../../../model/OperationModel';
import { useOperationStore } from '../../../../../stores/OperationStore';
import { CASH_ID, CountryEnum, DELIVERY_MESSAGE, Employee, MONTHLY_BILLING, TWO_HUNDRED_SUCCESS_CODE, UserEnum, isAccessible, isEmptyCheck } from '../../../../../utils/app-common';
import { getNotificationStyle } from '../../../../../common/notification';
import { requiredValidation } from '../../../../../validation/validation';
import ConfirmationModal from '../../../../CommonComponent/ConfirmationModal';
import LoadingModalComponent from '../../../../CommonComponent/LoadingModalComponent';
import AuditModalComponent from '../../../../TrackingHistoryComponent/AuditComponent';
import { AgreementTrackingComponent } from './AgreementTrackingComponent';
import ButtonComponent from './ButtonComponent';
import ContentComponent from './ContentComponent';
import ManifestContextComponent from './Context/ManifestContextComponent';
import { useManifestContextHook } from './Context/useManifestContextHook';
import BindingHook from './hooks/BindingHook';
import InitialHook from './hooks/InitialHook';
import SaveHook from './hooks/SaveHook';
import { BsStopwatch } from 'react-icons/bs';

const manifestInitialValues: IManifestationRequest = {
    booking: '',
    bookingId: '',
    business: '',
    businessId: '',
    clientId: undefined,
    clientName: '',
    consignee: '',
    consigneeId: '',
    deliveryId: 0,
    id: undefined,
    manifestedDate: '',
    manifetDetail: {
        waybillNo: "",
        stdShipmentAmount: '',
        originOdaCharge: '',
        destOdaCharge: '',
        podCharges: '',
        insuranceCharges: '',
        additionalWeight: '',
        surCharge: '',
        netValue: '',
        modifedByEmpId: '',
        otherCharges: ''
    },
    pickupId: '',
    pieceCount: '',
    product: '',
    productId: undefined,
    salespersonIdEmpName: '',
    salespersonIdEmpid: '',
    shipper: '',
    shipperId: '',
    status: '',
    subProductId: undefined,
    subclientId: '',
    subclientName: '',
    temperature: '',
    temperatureId: '',
    waybillNo: '',
    weight: '',
    originOdaCityId: '',
    destinationOdaCityId: '',
    quotationPriceDetailList: [],
    confirmedByFinanceId: false,
    confirmedBySalespersonId: false
}

const HeaderBtnComponent = () => {


    const PushToOracleAction = useOperationStore(state => state.PushToOracleAction);
    const NORDeliveryAction = useOperationStore(state => state.NORDeliveryAction);
    const BulkHoldManifestAction = useOperationStore(state => state.BulkHoldManifestAction);
    const { promiseInProgress: deliveryProgress } = usePromiseTracker({ area: 'delivery-area' });
    const { promiseInProgress: holdManifestProgress } = usePromiseTracker({ area: 'hold-manifest-area' });

    const { onRefreshHandler } = InitialHook();
    const { billTypeId, fromOperation } = useOperationHook();
    const waybillNo = useWaybillResolver();
    const { isManifestorConfirmed, isDelivered, setIsAuditOpen, setIsTrackingOpen, setIsConfirmationModal, isConfirmationModal, isAuditOpen, isTrackingOpen, sentForOracleInvoicing, isInternational, isOracleInvoiced,
        pieceCount, agreementBillPeriod, deliveryId, readOnly, manifestOnHold } = useManifestContextHook();

    const [holdModalOpen, setHoldModalOpen] = useState(false);
    const [remarksForm] = Form.useForm();

    const isMonthlyBilling = (agreementBillPeriod === MONTHLY_BILLING);
    const isManifestDelivered = !((deliveryId && deliveryId > 0) || isDelivered);
    // const isPushToOracleHidden = (isInternational && (billTypeId && [CASH_ID].includes(billTypeId)))
    //     || isInternational
    //     || (!isManifestorConfirmed)
    //     || sentForOracleInvoicing;

    const isPushToOracleHidden = ((isInternational) ?
        (billTypeId && [CASH_ID].includes(billTypeId)) : isInternational) || (!isManifestorConfirmed) || sentForOracleInvoicing || isOracleInvoiced;
    const onAuditHandle = () => {
        if (!isEmptyCheck(waybillNo)) {
            setIsAuditOpen(true);
        };
    }

    const onTrackingHandle = () => {
        if (!isEmptyCheck(waybillNo)) {
            setIsTrackingOpen(true);
        };
    }

    const onDeliveryHandler = () => {
        setIsConfirmationModal(true);
    };

    const onPushToOracleHandler = () => {
        trackPromise(PushToOracleAction(waybillNo), 'push-to-oracle-area');
    };

    const onConfirmedClicked = () => {
        const request: Partial<INorDelivery> = {
            waybillNo: waybillNo,
            pieceCount: pieceCount
        };
        trackPromise(NORDeliveryAction(request), 'delivery-area');
    };

    const onHoldConfirm = async (values: { remarks: string }) => {
        const res = await trackPromise(
            BulkHoldManifestAction({ waybillNos: [waybillNo!], remarks: values.remarks.trim() }),
            'hold-manifest-area'
        );
        if (res?.status === TWO_HUNDRED_SUCCESS_CODE) {
            setHoldModalOpen(false);
            remarksForm.resetFields();
            onRefreshHandler();
            getNotificationStyle(res);
        }
    };
    console.log('isManifestorConfirmed', isManifestorConfirmed);
    return (
        <>
            <Row justify='end' gutter={[10, 50]} align='bottom' className='margin-bottom'
                hidden={!fromOperation || readOnly}
            >
                <Col hidden={isManifestorConfirmed || manifestOnHold || sentForOracleInvoicing || isOracleInvoiced || isInternational}>
                    <Button icon={<BsStopwatch size={18} />} onClick={() => { remarksForm.resetFields(); setHoldModalOpen(true); }} className='icon-button'> Hold Manifest Confirmation </Button>
                </Col>
                <Col hidden={isPushToOracleHidden}>
                    <Button icon={<GoRepoPush size={18} />} onClick={onPushToOracleHandler} className='icon-button'> Push to Oracle </Button>
                </Col>
                <Col>
                    <Button icon={<AiOutlineHistory size={18} />} onClick={onAuditHandle} className='icon-button'> Audit </Button>
                </Col>
                <Col hidden={isAccessible([UserEnum.FINANCE, UserEnum.SALES_MANAGER, UserEnum.FINANCE_CONTROLLER], [CountryEnum.BAHRAIN, CountryEnum.UAE, CountryEnum.KSA])}>
                    <Button icon={<AiOutlineHistory size={18} />} onClick={onTrackingHandle} className='icon-button'> Track Agreement </Button>
                </Col>
                <Col hidden={!((isMonthlyBilling && isManifestDelivered) || (isAccessible([UserEnum.SALES_MANAGER, UserEnum.MANIFESTER, UserEnum.OPERATION_CS_SUPERVISOR_MANIFESTER, UserEnum.FINANCE, UserEnum.OPS_MANAGER, UserEnum.FINANCE_CONTROLLER], [CountryEnum.BAHRAIN, CountryEnum.UAE, CountryEnum.KSA]) || isAccessible(
                    [Employee.IMATHUL_RAFI_KSA],
                    [CountryEnum.KSA],
                    true
                )))}>
                    <Button icon={<TbTruckDelivery size={18} />} onClick={onDeliveryHandler} className='icon-button'> Delivery </Button>
                </Col>
                {/* <Col hidden={(isAccessible([UserEnum.SALES_MANAGER, UserEnum.MANIFESTER, UserEnum.FINANCE, UserEnum.OPS_MANAGER, UserEnum.FINANCE_CONTROLLER]) ? !(isMonthlyBilling && isManifestDelivered) : true)}>
                    <Button icon={<TbTruckDelivery size={18} />} onClick={onDeliveryHandler} className='icon-button'> Delivery </Button>
                </Col> */}
                <Col>
                    <Button icon={<BiRefresh size={18} />} onClick={onRefreshHandler} />
                </Col>
            </Row>
            {isAuditOpen ? <AuditModalComponent isOpen={isAuditOpen} closeModal={() => setIsAuditOpen(false)} waybillNo={waybillNo} /> : null}
            {isTrackingOpen ? <AgreementTrackingComponent isOpen={isTrackingOpen} closeModal={() => setIsTrackingOpen(false)} /> : null}

            {
                manifestOnHold && <Alert
                    type="warning"
                    showIcon
                    message="Manifest confirmation is currently on hold. Auto invoice will not work on this waybill"
                    style={{ marginBottom: 16 }}
                />
            }

            <ConfirmationModal
                openModal={isConfirmationModal}
                promiseInProgress={deliveryProgress}
                confirmClicked={onConfirmedClicked}
                hideModal={() => setIsConfirmationModal(false)}
                label={DELIVERY_MESSAGE} />

            <Modal
                title="Hold Manifest Confirmation"
                open={holdModalOpen}
                onCancel={() => setHoldModalOpen(false)}
                onOk={() => remarksForm.submit()}
                okText="Confirm"
                confirmLoading={holdManifestProgress}
                destroyOnClose
                maskClosable={false}
            >
                <Alert
                    type="warning"
                    showIcon
                    message="Manifest confirmation will be put on hold. Auto invoice will not work on this waybill. Are you sure you want to proceed?"
                    style={{ marginBottom: 16 }}
                />
                <Typography.Text strong>Waybill</Typography.Text>
                <Space wrap style={{ marginTop: 8, marginBottom: 16, display: 'flex' }}>
                    <Tag color="blue">{waybillNo}</Tag>
                </Space>
                <Form form={remarksForm} onFinish={onHoldConfirm} layout="vertical">
                    <Form.Item
                        name="remarks"
                        label="Remarks"
                        rules={[
                            requiredValidation,
                            { max: 150, message: 'Remarks cannot exceed 150 characters' },
                        ]}
                    >
                        <Input.TextArea rows={6} placeholder="Enter remarks , Maximum 150 characters" allowClear maxLength={150} showCount />
                    </Form.Item>
                </Form>
            </Modal>
        </>
    )
}
const FormComponent = () => {

    const [form] = Form.useForm();
    const manifestFormRef: React.MutableRefObject<any> = useRef(null);
    const { setIsConfirmationModal } = useManifestContextHook();
    const norResponse = useOperationStore(state => state.norResponse);
    BindingHook({ manifestFormRef });
    const { onSubmit } = SaveHook();
    useEffect(() => {
        if (norResponse) {
            setIsConfirmationModal(false)
        }
    }, [norResponse, setIsConfirmationModal])

    return (
        <Form
            name="manifest"
            form={form}
            onFinish={onSubmit}
            initialValues={manifestInitialValues}
            autoComplete="off"
            ref={manifestFormRef}>
            <ContentComponent />
            <ButtonComponent form={form} />
        </Form>
    )
}

const ManifestComponent = ({ readOnly = false }: { readOnly?: boolean }) => {
    const { promiseInProgress: manifestProgress } = usePromiseTracker({ area: 'manifest-initial-area' });
    const { promiseInProgress: submitPromise } = usePromiseTracker({ area: 'button-click-area' });
    const { promiseInProgress: fetchPromise } = usePromiseTracker({ area: 'fetch-area' });
    const { promiseInProgress: fileListPromise } = usePromiseTracker(({ area: 'manifest-file-area' }));
    const { promiseInProgress: updateBillTypePromise } = usePromiseTracker(({ area: 'update-bill-type' }));
    const { promiseInProgress: clearCityPromise } = usePromiseTracker(({ area: 'city-clear-area' }));
    const { promiseInProgress: pushToOraclePromise } = usePromiseTracker(({ area: 'push-to-oracle-area' }));
    const { promiseInProgress: deliveryProgress } = usePromiseTracker({ area: 'delivery-area' })
    const isFromParam = useIsWaybillFromParam();
    return (
        <LoadingModalComponent isLoading={manifestProgress || submitPromise || fetchPromise || fileListPromise || updateBillTypePromise || clearCityPromise || deliveryProgress || pushToOraclePromise}>
            <ManifestContextComponent readOnly={readOnly}>
                <div style={isFromParam ? { pointerEvents: 'none', opacity: 0.6 } : undefined}>
                    <HeaderBtnComponent />
                    <FormComponent />
                </div>
            </ManifestContextComponent>
        </LoadingModalComponent >
    )
}
export default ManifestComponent